module.exports = __webpack_public_path__ + "static/media/coding1.c0af511f.svg";